export default "__VITE_ASSET__BiVwYQG___"